import { createSelector } from 'reselect';
import { getFormValues, isInvalid } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { initialState } from './reducer';
import { FORM_NAME } from './constants';

export const selectCargoFetchModalDomain = state => state.cargoFetchModalReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getIsReqInfoLoadingSelector = () =>
	createSelector(selectCargoFetchModalDomain, ({ isReqInfoLoading }) => isReqInfoLoading);

export const getIsFormSendingSelector = () =>
	createSelector(selectCargoFetchModalDomain, ({ isFormSending }) => isFormSending);

export const getReqInfoSelector = () =>
	createSelector(selectCargoFetchModalDomain, ({ reqInfo }) => {
		return reqInfo;
	});

export const getFormInitialValuesSelector = () =>
	createSelector(selectCargoFetchModalDomain, ({ reqInfo }) => {
		if (!reqInfo) {
			return {};
		}

		return {
			type: reqInfo?.type?.name,
			state: 'Без повреждений',
			points: reqInfo?.points?.map(point => {
				return {
					type_seat: point?.type_seat,
					weight: point?.weight,
					volume: point?.volume,
					place: point?.place,
					is_fetch: true,
				};
			}),
			container_state: 'Без замечаний',
			packaging_state: 'Без замечаний',
			body_state: 'Без замечаний',
		};
	});

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'cargo_fetch');
	});

export const getActiveReqIdSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return query?.modal === 'cargo_fetch' ? query?.id : null;
	});

export const getFormValuesSelector = () =>
	createSelector(getFormValues(FORM_NAME), formValues => {
		return {
			...formValues,
			date_arrival: moment(`${formValues.date_arrival} ${formValues.time_arrival}`).format('YYYY-MM-DD HH:mm'),
			date_departure: moment(`${formValues.date_departure} ${formValues.time_departure}`).format(
				'YYYY-MM-DD HH:mm',
			),
			points: formValues?.points?.map(point => ({
				type_seat: point?.is_fetch ? point?.type_seat : null,
				weight: point?.is_fetch ? point?.weight : null,
				volume: point?.is_fetch ? point?.volume : null,
				place: point?.is_fetch ? point?.place : null,
				is_fetch: point?.is_fetch || false,
			})),
		};
	});

export const getFormIsInvalidSelector = () => createSelector(isInvalid(FORM_NAME), isInvalid => isInvalid);

export const getIsActiveSelector = () =>
	createSelector(getFormValues(FORM_NAME), formValues => {
		return {
			points: formValues?.points?.map(point => Boolean(point.is_fetch)) || [],
		};
	});
